import Vue from 'vue'
import VueI18n from 'vue-i18n'
import defaultMessages from '@/i18n/languages/en'

import _ from 'lodash'

Vue.use(VueI18n)

const defaultLanguage = 'en'
const loadedLanguages = [defaultLanguage]
const unknownLanguages = []

export const i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages: { [defaultLanguage]: defaultMessages }
})

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

function handleLocaleNotFound (lang) {
  unknownLanguages.push(lang)

  const parts = lang.split('-')
  if (_.size(parts) > 1) {
    // Fallback to country-part of locale
    return loadLanguage(_.first(parts))
  } else {
    // Return the language that is currently active when all else fails
    return Promise.resolve(i18n.locale)
  }
}

export function loadLanguage (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang) && !unknownLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/languages/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      }).catch(() => handleLocaleNotFound(lang))
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}
